"use strict" ;

/**
 * This constant change radians to degrees : <code>180/Math.PI</code>.
 * @name RAD2DEG
 * @memberof core.maths
 * @const
 * @instance
 */
const RAD2DEG = 180 / Math.PI ;

export default RAD2DEG ;
